import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { fetchProducts } from "../../features/product/productSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faTwitter,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

const Footer = ({ products }) => {
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  //  const products  = useSelector((state) => state.product.data);
  console.log("Products from footer", products);
  const limitedProducts = products.slice(0, 6);

  //  useEffect(() => {
  //    // Fetch the first page of products with a limit of 10
  //    dispatch(fetchProducts({ page: 1, limit: 10 }));
  //  }, [dispatch]);

  const handleProductClick = (id) => {
    console.log("id:", id);
    navigate(`/productdetail/${id}`);
  };

  return (
    <>
      <footer className="footer bg-dark text-white pt-5">
        <div className="container">
          <div className="row">
            {/* Product Section */}
            <div className="col-md-3">
              <h5>PRODUCT</h5>
              <ul className="list-unstyled">
                {limitedProducts.map((product) => (
                  <li key={product._id}>
                    <a
                      href="#"
                      className="text-white text-decoration-none"
                      onClick={() => handleProductClick(product._id)}
                    >
                      {product.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Information Section */}
            <div className="col-md-3">
              <h5>INFORMATION</h5>
              <ul className="list-unstyled">
                <li>
                  <Link
                    to="/general-inquiry"
                    className="text-white text-decoration-none"
                  >
                    Our Services
                  </Link>
                </li>
                <li>
                  <Link to={"/bulk-inquiry"} className="text-white text-decoration-none">
                    Bulk/Wholesale
                  </Link>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">
                    Refund Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white text-decoration-none">
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </div>

            {/* Company Section */}
            <div className="col-md-3">
              <h5>COMPANY</h5>
              <ul className="list-unstyled">
                <li>
                  <a href="/about" className="text-white text-decoration-none">
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    href="/contact"
                    className="text-white text-decoration-none"
                  >
                    Contact Us
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:info@neelgagan.com"
                    className="text-white text-decoration-none"
                  >
                    info@natraj.com
                  </a>
                </li>
              </ul>
            </div>

            {/* Subscribe Section */}
            <div className="col-md-3">
              <h5>SUBSCRIBE</h5>
              <p>
                Hello, we are Natraj. Our goal is to translate the positive
                effects from revolutionizing how companies engage with their
                clients & their team.
              </p>
              <div className="input-group">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email address"
                />
                <button className="btn btn-danger" type="button">
                  N
                </button>
              </div>
            </div>
          </div>

          <hr className="border-top border-light" />

          {/* Footer Bottom Section */}
          <div className="row">
            <div className="col-md-6">
              <img src="natraj-logo.png" alt="Natraj" className="logo mb-2" />
              <p>&copy; 2024 Natraj | Powered By Natraj</p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="social-icons">
                <a href="#" className="text-white me-3">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="#" className="text-white me-3">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
                <a href="#" className="text-white me-3">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
                <a href="#" className="text-white">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* WhatsApp Floating Button */}
        <a
          href="https://wa.me/1234567890"
          className="whatsapp-float position-fixed text-success"
          style={{ bottom: "20px", right: "20px", fontSize: "24px" }}
        >
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
      </footer>
    </>
  );
};

export default Footer;
